import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaCaretDown, FaSlidersH } from "react-icons/fa";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import PlaceHolder from "../../../../assets/images/Placeholder.png";
import { FadeLoader } from "react-spinners";
import MsgModal from "../../modals/MsgModal";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Button,
  Container,
} from "reactstrap";
import "../LcaCards.css"; // Import your custom CSS file
import moment from "moment-timezone";
import "moment-timezone/builds/moment-timezone-with-data";
import { fetchBWV, fetchUserDetails } from "../../Data";
import CarouselComponent from "../BizzList";
import GitHubForkRibbon from "react-github-fork-ribbon";
import BwvBox from "../BwvBox";

const BwvCards2 = ({ allProducts, setLoading, carouselData }) => {
  const location = useLocation();
  const islogin = useSelector((state) => state.user.isLogin);
  const userdata = useSelector((state) => state.user);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [isMessage, setIsMessage] = useState(false);
  const [isMsgModalOpen, setIsMsgModalOpen] = useState(false);
  const [isOfferModalOpen, setIsOfferModalOpen] = useState(false);
  const [selectedAd, setSelectedAd] = useState(null);
  const navigate = useNavigate();
  const [imageIndex, setImageIndex] = useState({});
  const { bwvLoading } = useSelector((state) => state.lcAds);
  const closeModal = () => {
    setIsMsgModalOpen(false);
    // setIsOfferModalOpen(false);
    setSelectedAd(null);
    // setSchedule(false);
  };

  const handleCardClick = (selectedCard) => {
    const screenWidth = window.innerWidth;
    const isIpadPro = screenWidth === 1024; // Check for iPad Pro screen width
    let Id = selectedCard.Id;
    if (!isMsgModalOpen && !isOfferModalOpen) {
      if (isIpadPro) {
        navigate(`/vendordetails/${Id}`);
      } else {
        window.open(`#/vendordetails/${Id}`, "_blank");
      }
    }
  };

  if (!allProducts) {
    <p>No Ads</p>;
    return;
  }
  function convertTo12HourFormat(time24) {
    if (!time24) {
      return "";
    }
    const [hour24, minute] = time24.split(":").map(Number);
    if (isNaN(hour24) || isNaN(minute)) {
      return "";
    }
    const period = hour24 >= 12 ? "PM" : "AM";
    const hour12 = (hour24 % 12 || 12).toString().padStart(2, "0"); // Added padStart
    return `${hour12}:${minute.toString().padStart(2, "0")} ${period}`;
  }

  function formatDate(inputDate) {
    let date = new Date(inputDate);
    let monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let year = date.getFullYear();
    let month = monthNames[date.getMonth()];
    let day = date.getDate();
    let formattedDay = day < 10 ? "0" + day : day;
    let formattedDate = `${month} ${formattedDay}, ${year}`;
    return formattedDate;
  }
  const openMsgModal = (event, ad) => {
    event.stopPropagation();
    if (!islogin) {
      toast.info("Please Login");
      navigate("/login");
    } else {
      setIsMessage(true);
      setIsMsgModalOpen(true);
      setSelectedAd(ad);
    }
  };
  function convertToUserTimezone(utcTime) {
    let timezone = "America/Los_Angeles"; // Default to system timezone
    if (islogin && user?.TimeZone) {
      timezone = user?.TimeZone.split(",")[0];
    }
    const localTime = moment
      .utc(utcTime)
      .tz(timezone)
      .format("YYYY-MM-DD HH:mm:ss");
    return localTime;
  }

  const handleNextImage = (event, ad) => {
    event.stopPropagation();
    const currentIndex = imageIndex[ad.Id] || 0;
    const images = JSON.parse(ad.Photo);
    const nextIndex = (currentIndex + 1) % images.length;
    setImageIndex({ ...imageIndex, [ad.Id]: nextIndex });
  };

  const handlePrevImage = (event, ad) => {
    event.stopPropagation();
    const currentIndex = imageIndex[ad.Id] || 0;
    const images = JSON.parse(ad.Photo);
    const prevIndex = (currentIndex - 1 + images.length) % images.length;
    setImageIndex({ ...imageIndex, [ad.Id]: prevIndex });
  };
  if (!allProducts.length) {
    return <div>No products available</div>; // Fallback UI
  }
  //   Verified & Trusted should be on top
  let sortverified = allProducts.sort((a, b) => {
    if (a.caIdStatus === 100 && b.caIdStatus !== 100) {
      return -1; // a comes before b
    } else if (a.caIdStatus !== 100 && b.caIdStatus === 100) {
      return 1; // b comes before a
    } else {
      return 0; // a and b are equal
    }
  });

  if (bwvLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "40vh" }}
      >
        <FadeLoader color={"#36D7B7"} />
      </div>
    );
  }
  return (
    <Container>
      {allProducts && allProducts.length > 0 ? (
        <>
          {allProducts.map((ad, index) => (
            <div key={ad.Id}>
              <p className="mb-0" style={{ fontSize: "medium" }}>
                {ad?.FullName}
              </p>
              <BwvBox ad={ad} />
              {index === 2 && carouselData.row1.length > 0 && (
                <Card className="my-2 mb-0 border-white">
                  <CarouselComponent items={carouselData.row1} />
                </Card>
              )}
              {index === 5 && carouselData.row2.length > 0 && (
                <Card className="my-2 mb-0 border-white">
                  <CarouselComponent items={carouselData.row2} />
                </Card>
              )}
              {index === 8 && carouselData.row3.length > 0 && (
                <Card className="my-2 mb-0 border-white">
                  <CarouselComponent items={carouselData.row3} />
                </Card>
              )}
            </div>
          ))}
        </>
      ) : (
        <div className="text-center my-5"></div>
        // <div
        //   className="text-center py-5 text-primary"
        //   style={{
        //     display: "flex",
        //     alignItems: "center",
        //     justifyContent: "center",
        //     margin: "50px 0px",
        //   }}
        // >
        //   <p
        //     style={{
        //       display: "flex",
        //       alignItems: "center",
        //       justifyContent: "center",
        //       margin: "10px 0px",
        //       fontSize: "20px",
        //     }}
        //     className="text-center py-5"
        //   >
        //     No cards to display
        //   </p>
        // </div>
      )}

      <MsgModal
        isOpen={isMsgModalOpen}
        closeModal={closeModal}
        selectedCard={selectedAd}
      />
    </Container>
  );
};

export default BwvCards2;
